
import React, { PropTypes } from 'react';
import IndexListItem from './IndexListItem';

const IndexsList = ({ lang, edition, content, toggleIndex, onClickIndexItem, title, params }) => {
  const classNames = 'content-index content-index--workshops content-list content-list--full-node';
  const isInner = typeof params.id !== 'undefined';
  return (
    <section className="fold__col fold__col--index">
      <header className="fold__col__header">
        <button onClick={toggleIndex} className="fold--index__toggle btn-toggle btn--text" />
        {
          lang === 'ar' ?
            <h2 className="fold__col__title">{title.arabic}</h2> :
            <h2 className="fold__col__title">
              <span className="fold__col__title__initial">{title.initial}</span>
              <span className="fold__col__title__rest">{title.rest}</span>
            </h2>
        }
      </header>
      <div className="fold__col__body fold__col__body--workhops">
        <ul className={classNames}>
          {content.map(({ ...rest, id }) =>
            <IndexListItem
              isInner={isInner}
              onClick={onClickIndexItem}
              lang={lang} key={id}
              {...rest}
              color={edition.background}
              edition={edition.id}
            />,
          )}
        </ul>
      </div>
    </section>
  );
};

IndexsList.propTypes = {
  lang: PropTypes.string.isRequired,
  content: PropTypes.arrayOf(PropTypes.object).isRequired,
  edition: PropTypes.shape({
    id: PropTypes.string,
  }).isRequired,
  toggleIndex: PropTypes.func.isRequired,
  onClickIndexItem: PropTypes.func.isRequired,
  title: PropTypes.objectOf(PropTypes.string).isRequired,
  params: PropTypes.objectOf(PropTypes.string).isRequired,
};

export default IndexsList;



// WEBPACK FOOTER //
// ./js/components/indexFold/IndexList.js